import React, { useEffect } from 'react';
import UnifiedHeader from '../layout/UnifiedHeader';
import Footer from '../layout/Footer';
import ServicesSection from '../sections/ServicesSection';
import PricingSection from '../sections/PricingSection';
import AboutSection from '../sections/AboutSection';
import FaqSection from '../sections/FaqSection';
import { updateMeta } from '../../utils/meta';
import { setJsonLdWithId } from '../../utils/seo';

export const ServicesPage: React.FC = () => {
  useEffect(() => {
    const origin = window.location.origin;
    updateMeta({
      title: 'Services - Paokhum',
      description: 'Websites, Branding, and CCTV streaming — tailored for Northeast businesses.',
      image: '/images/og/home.svg',
      url: origin + '/services'
    });

    // Service JSON-LD (aggregate)
    try {
      setJsonLdWithId('services', {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Web Development, Branding & CCTV Streaming",
        "provider": { "@type": "Organization", "name": "Paokhum" },
        "areaServed": ["Imphal", "Manipur", "Guwahati", "Nagaland", "Northeast India"],
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Paokhum Services",
          "itemListElement": [
            { "@type": "Service", "name": "Website Development" },
            { "@type": "Service", "name": "Branding & Design" },
            { "@type": "Service", "name": "CCTV Streaming to Web" }
          ]
        }
      });
    } catch {}
  }, []);
  return (
    <div className="relative">
      <UnifiedHeader />
      <main className="min-h-screen relative">
        <ServicesSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
};

export const PricingPage: React.FC = () => {
  useEffect(() => {
    const origin = window.location.origin;
    updateMeta({
      title: 'Pricing - Paokhum',
      description: 'Transparent pricing for websites, branding, and CCTV streaming.',
      image: '/images/og/pricing.svg',
      url: origin + '/pricing'
    });
  }, []);
  return (
    <div className="relative">
      <UnifiedHeader />
      <main className="min-h-screen relative">
        <PricingSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
};

export const AboutPage: React.FC = () => {
  useEffect(() => {
    updateMeta({
      title: 'About - Paokhum',
      description: 'We architect digital experiences that connect & convert.',
      image: '/images/og/home.svg',
      url: window.location.origin + '/about'
    });
  }, []);
  return (
    <div className="relative">
      <UnifiedHeader />
      <main className="min-h-screen relative">
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
};

export const ContactPage: React.FC = () => {
  useEffect(() => {
    updateMeta({
      title: 'Contact - Paokhum',
      description: 'Talk to us about your website, branding, or CCTV project.',
      image: '/images/og/home.svg',
      url: window.location.origin + '/contact'
    });
  }, []);
  return (
    <div className="relative">
      <UnifiedHeader />
      <main className="min-h-screen relative">
        {/* Keep a simple contact CTA — the popup is globally available */}
        <section className="py-24">
          <div className="container mx-auto px-6">
            <h1 className="text-4xl font-display font-extrabold mb-4">Contact Paokhum</h1>
            <p className="text-foreground/70 mb-6">Use the Contact Us button in the header or footer to reach us instantly.</p>
          </div>
        </section>
        <PricingSection />
      </main>
      <Footer />
    </div>
  );
};

